export default "/assets/images/mila-feed-13-thumbnail.1521e25fbd41dfeb.jpg";